import { render, staticRenderFns } from "./FormTiresNDisks.vue?vue&type=template&id=1cf572de&scoped=true&"
import script from "./FormTiresNDisks.vue?vue&type=script&lang=js&"
export * from "./FormTiresNDisks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf572de",
  null
  
)

export default component.exports